<div class="flex flex-col h-full">

  <div class="flex flex-col gap-6 h-full">

    <!-- Part 1 -->
    <div class="bg-violet-100 dark:bg-[#252c5f] rounded-xl p-6 flex flex-col justify-center flex-1">

      <div>
        <h2 class="text-xl !text-secondary-900 dark:!text-white font-semibold mb-3">Enrich Profile</h2>
        <p class="!text-secondary dark:!text-primary-200 mb-6">Leverage our advanced AI technology to automatically enhance the profile with relevant insights, skills, and achievements.</p>

        <div class="flex items-center space-x-3">

          <button
            type="button"
            class="btn bg-violet-500 hover:bg-violet-600 transition-colors shadow shadow-violet-200"
            (click)="enhanceProfile()"
            (mouseenter)="isButtonHovered = true"
            (mouseleave)="isButtonHovered = false"
            [disabled]="enrichmentLoading$ | async">
            <span *ngIf="!(enrichmentLoading$ | async)" class="!text-white !font-medium">Enrich Profile</span>
            <span *ngIf="enrichmentLoading$ | async" class="!text-white !font-medium">Enriching...</span>
          </button>

          <p class="text-xs tracking-wide font-medium">
            <span class="!text-violet-600 dark:!text-violet-400 font-semibold">2 credits</span>
          </p>
        </div>

      </div>

    </div>

    <!-- Part 2 -->
    <div class="flex flex-col justify-center flex-1">

      <!-- Data Enhancement Grid -->
      <div class="grid lg:grid-cols-3 rounded-xl overflow-hidden h-full">

        <!-- Expertise Box -->
        <div class="group relative items-center bg-violet-100 dark:bg-[#252c5f] p-6 border-r border-b border-violet-50 dark:border-secondary-800">

          <div class="flex justify-between items-center w-full">
            <div class="flex flex-col items-start justify-center h-full min-h-[60px]">
              <span class="text-sm font-semibold !text-secondary dark:!text-primary-200">Expertise</span>
              <span class="text-[10px] !text-secondary dark:!text-primary-200 mt-1">Professional skills & competencies</span>
            </div>
            <div class="icon-container relative w-5 h-5">
              <svg *ngIf="!isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary">
                <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clip-rule="evenodd" />
              </svg>
              <svg *ngIf="isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary" style="transform: translateX(2px)">
                <path fill-rule="evenodd" d="M14.5 1A4.5 4.5 0 0 0 10 5.5V9H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.5V5.5a3 3 0 1 1 6 0v2.75a.75.75 0 0 0 1.5 0V5.5A4.5 4.5 0 0 0 14.5 1Z" clip-rule="evenodd" />
              </svg>
            </div>
          </div>

        </div>

        <!-- Background Box -->
        <div class="group relative items-center bg-violet-100 dark:bg-[#252c5f] p-6 border-r border-b border-violet-50 dark:border-secondary-800">

          <div class="flex justify-between items-center w-full">

            <div class="flex flex-col items-start justify-center h-full min-h-[60px]">
              <span class="text-sm font-semibold !text-secondary dark:text-gray-200">Background</span>
              <span class="text-[10px] !text-secondary dark:text-gray-400 mt-1">Career history & experience</span>
            </div>
            <div class="icon-container relative w-5 h-5">
              <svg *ngIf="!isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary">
                <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clip-rule="evenodd" />
              </svg>
              <svg *ngIf="isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary" style="transform: translateX(2px)">
                <path fill-rule="evenodd" d="M14.5 1A4.5 4.5 0 0 0 10 5.5V9H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.5V5.5a3 3 0 1 1 6 0v2.75a.75.75 0 0 0 1.5 0V5.5A4.5 4.5 0 0 0 14.5 1Z" clip-rule="evenodd" />
              </svg>
            </div>

          </div>

        </div>

        <!-- Company News Box -->
        <div class="group relative bg-violet-100 dark:bg-[#252c5f] p-6 border-r border-b border-violet-50 dark:border-secondary-800">

          <div class="flex justify-between items-center w-full">

            <div class="flex flex-col items-start justify-center h-full min-h-[60px]">
              <span class="text-sm font-semibold !text-secondary dark:text-gray-200">Company News</span>
              <span class="text-[10px] !text-secondary dark:text-gray-400 mt-1">Latest updates & announcements</span>
            </div>
            <div class="icon-container relative w-5 h-5">
              <svg *ngIf="!isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary">
                <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clip-rule="evenodd" />
              </svg>
              <svg *ngIf="isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary" style="transform: translateX(2px)">
                <path fill-rule="evenodd" d="M14.5 1A4.5 4.5 0 0 0 10 5.5V9H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.5V5.5a3 3 0 1 1 6 0v2.75a.75.75 0 0 0 1.5 0V5.5A4.5 4.5 0 0 0 14.5 1Z" clip-rule="evenodd" />
              </svg>
            </div>

          </div>

        </div>

        <!-- Company Info Box -->
        <div class="group relative items-center bg-violet-100 dark:bg-[#252c5f] p-6 border-r border-b border-violet-50 dark:border-secondary-800">

          <div class="flex justify-between items-center w-full">

            <div class="flex flex-col items-start justify-center h-full min-h-[60px]">
              <span class="text-sm font-semibold !text-secondary dark:text-gray-200">Company Info</span>
              <span class="text-[10px] !text-secondary dark:text-gray-400 mt-1">Organization details & metrics</span>
            </div>
            <div class="icon-container relative w-5 h-5">
              <svg *ngIf="!isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary">
                <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clip-rule="evenodd" />
              </svg>
              <svg *ngIf="isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary" style="transform: translateX(2px)">
                <path fill-rule="evenodd" d="M14.5 1A4.5 4.5 0 0 0 10 5.5V9H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.5V5.5a3 3 0 1 1 6 0v2.75a.75.75 0 0 0 1.5 0V5.5A4.5 4.5 0 0 0 14.5 1Z" clip-rule="evenodd" />
              </svg>
            </div>

          </div>

        </div>

        <!-- AI Insights Box -->
        <div class="group relative items-center bg-violet-100 dark:bg-[#252c5f] p-6 border-r border-b border-violet-50 dark:border-secondary-800">

          <div class="flex justify-between items-center w-full">

            <div class="flex flex-col items-start justify-center h-full min-h-[60px]">
              <span class="text-sm font-semibold !text-secondary dark:text-gray-200">AI Insights</span>
              <span class="text-[10px] !text-secondary dark:text-gray-400 mt-1">Smart recommendations</span>
            </div>
            <div class="icon-container relative w-5 h-5">
              <svg *ngIf="!isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary">
                <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clip-rule="evenodd" />
              </svg>
              <svg *ngIf="isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary" style="transform: translateX(2px)">
                <path fill-rule="evenodd" d="M14.5 1A4.5 4.5 0 0 0 10 5.5V9H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.5V5.5a3 3 0 1 1 6 0v2.75a.75.75 0 0 0 1.5 0V5.5A4.5 4.5 0 0 0 14.5 1Z" clip-rule="evenodd" />
              </svg>
            </div>

          </div>

        </div>

        <!-- Additional placeholder box for 3x2 grid balance -->
        <div class="group relative items-center bg-violet-100 dark:bg-[#252c5f] p-6 border-r border-b border-violet-50 dark:border-secondary-800">

          <!--
          <div class="flex justify-between items-center w-full">

            <div class="flex flex-col items-start justify-center h-full min-h-[60px]">
              <span class="text-sm font-semibold !text-secondary dark:text-gray-200">More Insights</span>
              <span class="text-[10px] !text-secondary dark:text-gray-400 mt-1">Additional data points</span>
            </div>
            <div class="icon-container relative w-5 h-5">
              <svg *ngIf="!isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary">
                <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clip-rule="evenodd" />
              </svg>
              <svg *ngIf="isButtonHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="absolute inset-0 w-5 h-5 text-secondary" style="transform: translateX(2px)">
                <path fill-rule="evenodd" d="M14.5 1A4.5 4.5 0 0 0 10 5.5V9H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.5V5.5a3 3 0 1 1 6 0v2.75a.75.75 0 0 0 1.5 0V5.5A4.5 4.5 0 0 0 14.5 1Z" clip-rule="evenodd" />
              </svg>
            </div>

          </div>
          -->

        </div>

      </div>

    </div>

  </div>

</div>
